import { Component, Input, OnInit } from '@angular/core';
import { AddressDto } from '@hub/generated/models';
import { eCountry } from '@hub/generated/enums';

@Component({
  selector: 'g-columnAddress',
  templateUrl: './columnAddress.component.html'
})
export class ColumnAddressComponent implements OnInit {
  constructor() {}

  @Input() data: AddressDto;
  @Input() isEditing: boolean = false;

  eCountry = eCountry;

  ngOnInit() {
  }
}
